import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import { ButtonStyled } from './style'

// Con `loading`, el spinner sustituye a icono y texto (sin cambiar el ancho) mientras dura la petición
const ButtonWithIcon = ( { title, Icon, onClick,remove, disabled = false, isDeleteOfferBtn= false, svgFill = false, tooltip = false, loading = false } ) => {
    return (
        <ButtonStyled disabled={ disabled || loading } className="no-print" remove={remove} onClick={onClick} svgFill={svgFill} tooltip={tooltip}
                        style={isDeleteOfferBtn ? {position: 'absolute', minWidth: 36, maxHeight: 32, padding: '0 !important'} : {}} isDeleteOfferBtn={isDeleteOfferBtn}>
            {/* Cargando: el spinner tapa icono y texto, que siguen ocupando su sitio para no mover el botón */}
            <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', visibility: loading ? 'hidden' : 'visible' }}>
                    {Icon && Icon}
                    {title}
                </span>
                {loading && <CircularProgress size={16} color="inherit" style={{ position: 'absolute' }} />}
            </span>
        </ButtonStyled>
    )
}

ButtonWithIcon.propType = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    Icon: PropTypes.func
}

export default ButtonWithIcon;